module.exports = __webpack_public_path__ + "static/media/Oppaat_ei_sis_hh_2013_SUOMI.e64e5b9b.jpg";